import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import GeneratorPage from "./pages/GeneratorPage";
import SetlistPage from "./pages/SetlistPage";
import FeaturesPage from "./pages/FeaturesPage";
import ErrorPage from "./pages/ErrorPage";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AudioPlayerProvider>
          <Router>
            <Navigation />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/generate" element={<GeneratorPage />} />
              <Route path="/setlist" element={<SetlistPage />} />
              <Route path="/features" element={<FeaturesPage />} />

              {/* Error routes */}
              <Route path="/error" element={<ErrorPage />} />
              <Route
                path="/401"
                element={<Navigate to="/error?code=401" replace />}
              />
              <Route
                path="/403"
                element={<Navigate to="/error?code=403" replace />}
              />
              <Route
                path="/404"
                element={<Navigate to="/error?code=404" replace />}
              />

              {/* Catch-all for undefined routes */}
              <Route
                path="*"
                element={
                  <Navigate to="/error?code=404&message=Page not found" replace />
                }
              />
            </Routes>
            <Footer />
          </Router>
        </AudioPlayerProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
